import {memo} from 'react'

import styles from './ParametersEmpty.css'

function ParametersEmptyComponent() {
  return (
    <div role={'cell'} className={styles.placeholder}>
      {'Nothing found'}
    </div>
  )
}

export const ParametersEmpty = memo(ParametersEmptyComponent)
